import React from 'react';
import { Icon } from '@iconify/react';
import { AppButton, AppModal } from '../ui';

const KkpWebConflictAlert = ({ show = false, warnings = [], onClose }) => (
  <AppModal
    show={show && Boolean(warnings?.length)}
    size="lg"
    centered
    onClose={onClose}
    labelledBy="kkp-web-conflict-modal-title"
    contentClassName="border-warning"
    headerClassName="bg-warning-100"
    title={(
      <span className="d-flex align-items-center gap-2" id="kkp-web-conflict-modal-title">
        <Icon icon="mdi:alert-outline" className="text-warning-emphasis" width={24} />
        Conflit — modification refusée
      </span>
    )}
    footer={<AppButton variant="warning" onClick={onClose}>J&apos;ai compris</AppButton>}
  >
    <p className="mb-3">
      Cette modification n&apos;a pas été enregistrée : elle entre en conflit avec les règles
      Indispo du planning WEB (PAVE KKP EXCLU, groupes EDITO / AGENDA).
    </p>
    <ul className="mb-0 ps-3">
      {warnings.map((warning) => (
        <li key={`${warning.code}-${warning.message}`} className="mb-2">
          {warning.message}
        </li>
      ))}
    </ul>
  </AppModal>
);

export default KkpWebConflictAlert;
